import React, { Component, Suspense } from 'react';
import MovieBrowser from './modules/movie-browser/movie-browser.container';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'

class App extends Component {
  render() {
    return (
      // Provides the Material UI theme to child components
      <MuiThemeProvider>
         <Suspense fallback={<div>Loading...</div>}>
                <MovieBrowser />
         </Suspense>                
      </MuiThemeProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js